<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import i18n from "@/i18n";
import moment from "moment";
import { sessionHelper, sharedHelper } from "@/utils";
import { SHARED, DATE } from "@/constants";
import { mapState } from "vuex";
import { CONFIGURATION_MODULE } from '@/state/modules/configuration'
import { configurationMethods } from "@/state/helpers";

export default {
  page: {
    title: i18n.t("label.listingX", [i18n.t('module.configuration')]),
  },
  async created() {
    await this.validPermissions();

    if (this.readPermission == true) {
      this.getAllConfigurations();
    }
  },
  components: { Layout, PageHeader },
  data() {
    return {
      title: i18n.t("label.listingX", [i18n.t('module.configuration')]),
      items: [
        {
          text: i18n.t("module.dashboard"),
          href: "/",
        },
        {
          text: i18n.t("module.configuration"),
          active: true,
        },
      ],
      permissions: sessionHelper.getPermissions(),
      readPermission: null,
      updatePermission: null,
      perPage: SHARED.DEFAULT_PAGE_SIZE,
      fields: [
        { key: "key", sortable: true, label: i18n.t("label.key"), },
        { key: "value", sortable: false, label: i18n.t("label.value"), },
        { key: "updatedAt", sortable: true, label: i18n.t("label.updatedAt"), },
        { key: "Action", sortable: false, label: i18n.t("label.action"), },
      ],
    };
  },
  computed: {
    ...mapState(CONFIGURATION_MODULE, ["status"]),
    tableRows() {
      return this.$store.state.configuration.list.data;
    },
  },
  mounted() { },
  methods: {
    ...configurationMethods,
    async validPermissions() {
      var jsonPermissions = JSON.parse(this.permissions)
      if (jsonPermissions.some(p => p.code === "CONFIG_READ")) {
        this.readPermission = true;
      }
      else {
        this.readPermission = false;
      }

      if (jsonPermissions.some(p => p.code === "CONFIG_UPDATE")) {
        this.updatePermission = true;
      }
      else {
        this.updatePermission = false;
      }
    },
    keyLabel(key) {
      if (key == 'domain_check_interval_hours') {
        return i18n.t('label.checkIntervalHours');
      }
      return key;
    },
    formatDateTime(value) {
      return value ? moment(value).format(DATE.DATE_TIME_SHORT_TZ) : '-';
    },
    requestUpdate(configuration) {
      if (this.updatePermission != true) {
        return;
      }

      if (configuration.key == 'domain_check_interval_hours') {
        let value = Number(configuration.value);
        if (configuration.value == null || configuration.value === '' || isNaN(value) || value < 1 || value > 168) {
          sharedHelper.alertErrorMessageWithoutCode(i18n.t('message.validX', [i18n.t('label.checkIntervalHours')]));
          return;
        }
      }

      let data = {
        key: configuration.key,
        value: configuration.value,
      };

      this.updateConfiguration({ data });
    },
  },
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />

    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <div class="table-responsive mb-0">
              <b-table :items="tableRows" :fields="fields" responsive="sm" :per-page="perPage"
                v-if="readPermission == true">
                <template #cell(key)="data">
                  {{ keyLabel(tableRows[data.index].key) }}
                </template>

                <template #cell(value)="data">
                  <b-form-input v-if="tableRows[data.index].key == 'domain_check_interval_hours'" type="number" min="1"
                    max="168" v-model="tableRows[data.index].value" :disabled="updatePermission != true"
                    style="max-width: 200px;"></b-form-input>
                  <b-form-input v-else-if="tableRows[data.index].valueType == 'integer' || tableRows[data.index].valueType == 'double'"
                    type="number" v-model="tableRows[data.index].value" :disabled="updatePermission != true"
                    style="max-width: 200px;"></b-form-input>
                  <b-form-input v-else type="text" v-model="tableRows[data.index].value"
                    :disabled="updatePermission != true"></b-form-input>
                </template>

                <template #cell(updatedAt)="data">
                  {{ formatDateTime(tableRows[data.index].updatedAt) }}
                </template>

                <template #cell(action)="data">
                  <button type="button" class="btn btn-sm btn-info w-md waves-effect waves-light"
                    v-if="updatePermission == true" :disabled="status.update"
                    @click="requestUpdate(tableRows[data.index])">
                    {{ $t('label.save') }}
                  </button>
                </template>
              </b-table>
              <div style="text-align: center;" v-else>
                {{ $t('message.noPermissionMessage') }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>
